import styled from "styled-components";

export const TicketsCardWrapper = styled.div`
  margin-left: 30px;
  margin-right: 30px;
  flex: 1 1 50%;
  max-width: 50%;
  @media (max-width: 1440px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
`;

export const TicketsCard = styled.div`
  background: var(--bkg-secondary);
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  flex-grow: 1;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  height: 100%;
`;

export const TicketHeader = styled.div`
  padding-bottom: 8px;
  margin-bottom: 16px;
  h3 {
    margin: 0;
    font-size: 1.125rem;
    color: var(--main-color);
  }
  p {
    margin: 0;
    font-size: 0.875rem;
    color: var(--text-secondary);
  }
`;

export const TicketItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #444;
`;

export const TicketInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const TicketText = styled.div`
  margin-left: 16px;
  color: #f0f1f5;
  font-weight: medium;
  font-size: 1.125rem;
`;

export const ActionText = styled.div`
  font-size: 0.875rem;
  color: #616168;
`;

export const StatusAndDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const StatusDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;

  &.status-info {
    background-color: var(--info);
  }

  &.status-closed {
    background-color: var(--info);
  }

  &.status-progress {
    background-color: var(--progress);
  }

  &.status-completed {
    background-color: var(--success);
  }

  &.status-default {
    background-color: grey;
  }
`;

export const StatusText = styled.div`
  color: #ccc;
  font-size: 0.875rem;
`;

export const TicketDate = styled.div`
  color: #ccc;
  font-size: 0.75rem;
`;

export const ViewAll = styled.div`
  text-align: center;
  margin-top: 32px;
  font-size: 1rem;
  color: var(--info);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
